<template>
  <v-dialog
    v-model="disqualifyPrompt"
    max-width="650px"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card elevation="10" class="premium-card cf-dlg">
      <!-- Header -->
      <div class="header-gradient cf-dlg__head">
        <span class="cf-dlg__icon">
          <v-icon color="white">mdi-account-off-outline</v-icon>
        </span>
        <div class="cf-dlg__titles">
          <h3 class="header-title">{{ pageDescription }}</h3>
          <p class="header-subtitle">
            Reason recorded for disqualifying this nomination
          </p>
        </div>
        <v-btn
          icon
          class="close-btn"
          aria-label="Close"
          @click="closePrompt"
          :loading="closeLoading"
        >
          <v-icon v-if="!closeLoading">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Content -->
      <v-card-text class="cf-dlg__body">
        <!-- Candidate Info -->
        <div class="candidate-info cf-block" v-if="row">
          <div class="cf-block__head">
            <span class="section-icon-wrapper cf-block__icon">
              <v-icon size="20">mdi-account-details</v-icon>
            </span>
            <h3 class="cf-block__title">Candidate Information</h3>
          </div>

          <div class="candidate-data cf-info">
            <div class="cf-info__row">
              <span class="data-label">Name</span>
              <span class="data-value">{{
                row.MemberName || "Not Available"
              }}</span>
            </div>
            <div class="cf-info__row">
              <span class="data-label">LO</span>
              <span class="data-value">{{
                row.LomName || "Not Available"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Qualification Description -->
        <div
          v-if="row && row.QualificationDescription"
          class="qualification-desc-card cf-block"
        >
          <div class="cf-block__head">
            <span
              class="desc-icon-wrapper cf-block__icon cf-block__icon--accent"
            >
              <v-icon size="20">mdi-file-document-edit</v-icon>
            </span>
            <h3 class="cf-block__title">Qualification Description</h3>
          </div>
          <div class="desc-content">
            <span class="desc-text">{{
              stripHtml(row.QualificationDescription)
            }}</span>
          </div>
        </div>
      </v-card-text>

      <!-- Footer -->
      <v-card-actions class="cf-dlg__foot">
        <v-spacer></v-spacer>

        <v-btn
          depressed
          class="action-btn cancel-btn"
          @click="closePrompt"
          :loading="closeLoading"
        >
          <v-icon left size="18">mdi-close-circle</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid: true,
      ElectionOfficerFlag: false,
      records: {},
      disqualifyPrompt: true,
      closeLoading: false,
    };
  },
  methods: {
    closePrompt() {
      // small loading feedback on close
      this.closeLoading = true;
      setTimeout(() => {
        console.log("closePrompt called");
        this.closeLoading = false;
        this.$emit("hideDialog", this.ResultFlag);
      }, 220);
    },
    refreshPageData() {},
    stripHtml(html) {
      if (!html) return "";
      return html.replace(/<[^>]*>/g, "");
    },
  },
  mounted() {
    this.refreshPageData();
    const roleId = this.$session.get("RoleId") || "";
    this.RoleId = roleId;

    const ElectionOfficerFlag = this.$session.get("ElectionOfficerFlag") || "";
    this.ElectionOfficerFlag = ElectionOfficerFlag;
  },
};
</script>

<style lang="scss" scoped>
/* JCI approved palette */
.cf-dlg {
  --navy: #3a67b1;
  --aqua: #0097d7;
  --gold: #edbe38;
  --seafoam: #56bda3;
  --ink: #0a0f29;
  --text: #414042;
  --danger: #d20e0e;
  --muted: #6b7280;
  --line: #e3e9f3;
  --line-strong: #cdd8ea;
  --surface-tint: #f5f7fc;
  --accent: var(--navy);
  --ease: cubic-bezier(0.22, 0.61, 0.36, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);

  color: var(--text);
  font-family: "Poppins", "Roboto", sans-serif;
}
.cf-dlg.v-card {
  border-radius: 22px !important;
  overflow: hidden;
  box-shadow: 0 30px 70px -24px rgba(10, 15, 41, 0.55) !important;
}

/* ---------- Header ---------- */
.cf-dlg__head {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px;
  color: #ffffff;
  background: radial-gradient(
      120% 160% at 100% 0%,
      rgba(0, 151, 215, 0.75),
      transparent 55%
    ),
    linear-gradient(125deg, var(--navy), var(--navy) 45%, var(--aqua));

  &::after {
    content: "";
    position: absolute;
    right: -40px;
    top: -60px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    border: 1px dashed rgba(255, 255, 255, 0.22);
    animation: cf-spin 50s linear infinite;
    pointer-events: none;
  }
}
.cf-dlg__icon {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: cf-pop 600ms var(--ease-out) 120ms backwards;
}
.cf-dlg__titles {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-width: 0;
}
.header-title {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 700;
  line-height: 1.3;
  color: #ffffff;
}
.header-subtitle {
  margin: 2px 0 0;
  font-size: 0.84rem;
  color: rgba(255, 255, 255, 0.85);
}
.close-btn.v-btn {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
  transition: transform 180ms var(--ease), background-color 180ms var(--ease);

  .v-icon {
    color: #ffffff !important;
  }
  &:hover {
    transform: rotate(90deg);
    background: rgba(255, 255, 255, 0.24);
  }
}

/* ---------- Body ---------- */
.cf-dlg__body.v-card__text {
  padding: 22px !important;
  color: var(--text);
}
.cf-block {
  position: relative;
  padding: 16px 18px;
  margin-bottom: 16px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: 0 1px 2px rgba(10, 15, 41, 0.04),
    0 6px 16px -10px rgba(58, 103, 177, 0.35);
  animation: cf-fade 480ms var(--ease-out) backwards;
  transition: border-color 220ms var(--ease), box-shadow 220ms var(--ease);

  &:last-child {
    margin-bottom: 0;
  }
  &:nth-child(2) {
    animation-delay: 80ms;
  }
  &:hover {
    border-color: var(--line-strong);
  }
}
.cf-block__head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.cf-block__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: rgba(58, 103, 177, 0.1);

  .v-icon {
    color: var(--navy) !important;
  }
}
.cf-block__icon--seafoam {
  background: rgba(86, 189, 163, 0.16);

  .v-icon {
    color: #2f8f77 !important;
  }
}
.cf-block__icon--accent {
  background: rgba(0, 151, 215, 0.12);

  .v-icon {
    color: var(--aqua) !important;
  }
}
.cf-block__title {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--ink);
}
.cf-info {
  display: grid;
  gap: 8px;
}
.cf-info__row {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  align-items: baseline;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--surface-tint);
}
.data-label {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--muted);
}
.data-value {
  font-size: 0.93rem;
  font-weight: 600;
  color: var(--ink);
  overflow-wrap: anywhere;
}
.desc-content {
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--surface-tint);
  border-left: 4px solid var(--accent);
}
.desc-text {
  font-size: 0.9rem;
  line-height: 1.7;
  color: var(--text);
  white-space: pre-line;
  overflow-wrap: anywhere;
}

/* ---------- Inputs (score dialog) ---------- */
.premium-input,
.premium-textarea {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    background: #ffffff;
  }
  ::v-deep fieldset {
    border-color: var(--line-strong);
    border-radius: 12px;
  }
  &.v-input--is-focused ::v-deep .v-input__slot {
    box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.12);
  }
  &.v-input--is-disabled ::v-deep .v-input__slot {
    background: var(--surface-tint);
  }
}

/* ---------- Footer ---------- */
.cf-dlg__foot.v-card__actions {
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 22px 18px !important;
  border-top: 1px solid var(--line);
  background: linear-gradient(180deg, #ffffff, var(--surface-tint));
}
.score-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.cf-score-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ink);
  background: #ffffff;
  border: 1px solid var(--line-strong);
  font-variant-numeric: tabular-nums;
}
.cf-score-pill__label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--navy);
}
.cf-score-pill--interview .cf-score-pill__label {
  color: #2f8f77;
}
.cancel-btn.v-btn {
  height: 40px;
  padding: 0 18px !important;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.01em;
  color: var(--ink) !important;
  background: #ffffff !important;
  border: 1px solid var(--line-strong);
  transition: transform 180ms var(--ease), box-shadow 180ms var(--ease),
    border-color 180ms var(--ease);

  .v-icon {
    color: var(--muted) !important;
  }
  &:hover {
    transform: translateY(-2px);
    border-color: var(--navy);
    box-shadow: 0 10px 20px -14px rgba(58, 103, 177, 0.8);
  }
  &:focus-visible {
    outline: 3px solid rgba(0, 151, 215, 0.45);
    outline-offset: 2px;
  }
}

/* ---------- Transitions ---------- */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 320ms var(--ease-out), transform 320ms var(--ease-out);
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 599px) {
  .cf-dlg__head {
    padding: 16px;
  }
  .cf-dlg__body.v-card__text {
    padding: 16px !important;
  }
  .cf-block {
    padding: 14px;
  }
  .cf-info__row {
    grid-template-columns: minmax(0, 1fr);
    gap: 2px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cf-dlg *,
  .cf-dlg *::before,
  .cf-dlg *::after {
    animation: none !important;
    transition: none !important;
  }
}

@keyframes cf-fade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes cf-pop {
  from {
    opacity: 0;
    transform: scale(0.6) rotate(-12deg);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes cf-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
